import { getExperimentValue } from '@canvas/client-feature-flags/experiments';

const shouldShowUpdatedSidePanel = () => {
  const isBoardCardVisualUpdateEnabled = getExperimentValue(
    'boardCardUpdate',
    'enabled',
    {
      fireExperimentExposure: false,
    }
  );
  const isNewSetupPanelEnabled = getExperimentValue('setupPanel', 'enabled', {
    fireExperimentExposure: false,
  });

  return isNewSetupPanelEnabled || isBoardCardVisualUpdateEnabled;
};

export default shouldShowUpdatedSidePanel;
